import React, {FC} from 'react';
import styled from 'styled-components';

import {CardModel} from '../../../models/api/cardModel';
import {VisualContactModel} from '../../../models/api/visualContactModel';
import {ContactCardPanelId} from '../../../store/panels/panelStateBase';
import {ContactCardFooterActions} from './actions/contactCardFooterActions';
import {ContactCardFooterOpenDetailsContainer} from './contactCardFooterOpenDetailsContainer';

/*
 * Props.
 */

interface ContactCardFooterProps {
  panelId: ContactCardPanelId;
  card?: CardModel;
  isLoading: boolean;
  visualContact: VisualContactModel;
  userEmail: string;
}

/*
 * Style.
 */

const StyledContactCardFooterWrapperDiv = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  border-top: 1px solid ${(p) => p.theme.alphas.black30};
  padding: 16px;
`;

/*
 * Component.
 */

export const ContactCardFooter: FC<ContactCardFooterProps> = (props) => {
  const {panelId, isLoading, card, visualContact, userEmail} = props;

  // If the user is viewing their own card, do not show the actions.
  if (userEmail === visualContact.contact.handle) {
    return null;
  }
  if (isLoading) {
    return null;
  }
  return (
    <StyledContactCardFooterWrapperDiv>
      <ContactCardFooterOpenDetailsContainer panelId={panelId} card={card} />
      <ContactCardFooterActions panelId={panelId} card={card} visualContact={visualContact} />
    </StyledContactCardFooterWrapperDiv>
  );
};
